const gql = {
  query: `mutation updateCiamProfile( $input: CiamProfile!) {
        updateCiamProfile(input: $input){
          profile {
            email,
            firstName,
            lastName,
            middleName
          }
        }
      }`,
  variables: {
    input: {
      email: null,
      firstName: null,
      lastName: null,
      middleName: null
    },
  },
  meta: {
    label: "Update CIAM Profile",
  },
};

export default gql;
